/**
 * モーダル用スクロールロック（参照カウント方式）
 *
 * 複数のモーダルが同時に開いている場合でも、
 * 最初のモーダルが開いた時にロックし、最後のモーダルが閉じた時に解除する。
 */
import { useEffect } from 'react';

let lockCount = 0;
let savedOverflow = '';

function acquireScrollLock() {
  if (lockCount === 0) {
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  lockCount++;
}

function releaseScrollLock() {
  lockCount--;
  if (lockCount <= 0) {
    lockCount = 0;
    document.body.style.overflow = savedOverflow;
  }
}

/**
 * モーダル表示時に背景のスクロールをロックするフック
 * @param isOpen モーダルが開いているかどうか
 */
export function useScrollLock(isOpen: boolean) {
  useEffect(() => {
    if (isOpen) {
      acquireScrollLock();
      return () => releaseScrollLock();
    }
  }, [isOpen]);
}
